import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Button.module.css';

/**
 * <Button to="/demo">       internal link
 * <Button href="https://…"> external link (opens in a new tab)
 * <Button onClick={…}>      button
 * variant: primary | light | ghost | ghostDark      size: md | lg
 */
export default function Button({ to, href, variant = 'primary', size = 'md', icon: Icon, children, className = '', ...rest }) {
    const cls = `${styles.btn} ${styles[variant]} ${styles[size]} ${className}`;
    const inner = (
        <>
            <span>{children}</span>
            {Icon && <Icon size={size === 'lg' ? 16 : 14} strokeWidth={2.4} aria-hidden="true" />}
        </>
    );
    if (to) return <Link to={to} className={cls} {...rest}>{inner}</Link>;
    if (href) return <a href={href} className={cls} target="_blank" rel="noreferrer" {...rest}>{inner}</a>;
    return <button type="button" className={cls} {...rest}>{inner}</button>;
}
